/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from "@tanstack/react-query";
import { useSubscription } from "store/auth/auth-store";
import apiInputService from "services/apiInputService";

const getFilesSubmitted = async () => {
    const { data } = await apiInputService.get(`/ExternalData/updateMassive/file`);

    return data;
}

export const useFilesSubmittedForBulkUpload = (options?: any) => {
    const { subscription } = useSubscription();
    return useQuery(
        ["carga-massiva", subscription?.subscriptionId],
        getFilesSubmitted,
        {
            enabled: !!subscription?.subscriptionId,
            ...options,
        }
    );
}